import { Instance } from 'mobx-state-tree'
import { QuestionAnswersModelBase } from './QuestionAnswersModel.base'

/* The TypeScript type of an instance of QuestionAnswersModel */
export interface QuestionAnswersModelType extends Instance<typeof QuestionAnswersModel.Type> {}

/* A graphql query fragment builders for QuestionAnswersModel */
export {
  selectFromQuestionAnswers,
  questionAnswersModelPrimitives,
  QuestionAnswersModelSelector
} from './QuestionAnswersModel.base'

/**
 * QuestionAnswersModel
 */
export const QuestionAnswersModel = QuestionAnswersModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
